import Api from "@/lib/Api";

export default {
    state: {
        data: [],
    },
    mutations: {
        setData(state, payload) {
            state.data = payload
        }
    },
    actions: {
        async load({ commit }) {
            const response = await Api.getUsers();

            if (response.error) return

            commit('setData', response.message)
        }
    }
}